<template>
    <div class="centerPop">
        <!-- :show-close='false' -->
          <el-dialog v-dialogDrag :show-close='false' title="修改初始密码" :visible.sync="dialogVisible" width="560px" :modal-append-to-body="false">
           <div class="title">为保障您的账号安全，首次登录请修改初始密码。</div>
            <el-form
              :model="ruleForm"
              status-icon
              :rules="rules"
              ref="ruleForm"
              label-width="115px"
              class="demo-ruleForm"
            >
              <el-form-item label="原密码" prop="pass">
                <el-input v-model="ruleForm.pass" placeholder="请输入原密码"></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPass">
                <el-input v-model="ruleForm.newPass" placeholder="请输入新密码"></el-input>
              </el-form-item>
              <el-form-item label="确认新密码" prop="checkPass">
                <el-input v-model="ruleForm.checkPass" placeholder="请再次输入新密码"></el-input>
              </el-form-item>
            </el-form>
             <div slot="footer" class="dialog-footer">
               <el-button class="dialogBtn" type="primary" @click="submitForm('ruleForm'),dialogVisible == false">确 定</el-button>
             </div>
          </el-dialog>
        </div>
</template>
<script>
import {isPasswordValid} from '@/utils/validate.js'
export default {
    data(){
            var validatePass = (rule, value, callback) => {
                if (value === "" || !isPasswordValid(value)) {
                    callback(new Error("请输入8位以上的数字、字母、特殊字符中任意两类的组合"));
                } else {
                    if (this.ruleForm.checkPass !== "") {
                        this.$refs.ruleForm.validateField("checkPass");
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请再次输入密码"));
                } else if (value !== this.ruleForm.newPass) {
                    callback(new Error("两次输入密码不一致!"));
                } else {
                    callback();
                }
            };
        return {
            dialogVisible: false,
            ruleForm: {
                    pass: "",
                    newPass: "",
                    checkPass: ""
                },
            rules: {
                    pass: [{required: true, message: "请输入密码", trigger: "blur"}],
                    newPass: [{required: true, validator: validatePass, trigger: "blur"}],
                    checkPass: [
                        {required: true, validator: validatePass2, trigger: "blur"}
                    ]
                },
        }
    },
    methods:{

      

        openModel(){
                this.dialogVisible=true
        },
            // 修改密码
            submitForm(formName) {
              
           
                if (
                    this.ruleForm.newPass != this.ruleForm.checkPass ||
                    !isPasswordValid(this.ruleForm.newPass) ||
                    this.ruleForm.pass == "" ||
                    this.ruleForm.newPass == " "
                ) {
                    this.$refs[formName].validate(valid => {});
                    this.dialogVisible = true;
                   
                } else {
                    
                  
                    this.$axios
                        .post(
                            "/user/updatePassword?oldPassword=" +
                            this.ruleForm.pass +
                            "&newPassword=" +
                            this.ruleForm.newPass
                        )
                        .then(result => {
                            // console.log(result.data);
                            if (result.data.code == 0) {
                                this.$message({
                                    message: "修改成功!",
                                    type: "success",
                                    showClose: true,
                                    duration: 2000
                                });
                            
                                let ChangingInitialPw=sessionStorage.getItem('userid')+'true'
                                sessionStorage.setItem('ChangingInitialPw',ChangingInitialPw)
                                this.dialogVisible = false;
                               
                            }else{
                                this.$message({
                                    message:result.data.data,
                                    type: "error",
                                    showClose: true,
                                    duration: 5000
                                }); 
                            }
                        });
                }
            },
    }
}
</script>
<style scoped lang='scss'>
.title{
  height: 22px;
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  color: #575B6C;;
  line-height: 22px;
  margin-bottom: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/changePassword.vue